import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reservation"
export default class extends Controller {
  static targets = ["form", "totalPrice", "startDate", "endDate", "rentalId", "submitButton", "loadingIndicator", "errorContainer"]
  static values = {
    baseUrl: String,
    checkAvailabilityUrl: String
  }

  connect() {
    console.log("Reservation controller connected")
    this.updateTotalPrice()
  }

  updateTotalPrice() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget || !this.hasRentalIdTarget) {
      return
    }

    const startDate = this.startDateTarget.value
    const endDate = this.endDateTarget.value
    const rentalId = this.rentalIdTarget.value

    if (!startDate || !endDate || !rentalId) {
      return
    }

    this.showLoadingIndicator()
    this.clearErrors()

    fetch(`${this.checkAvailabilityUrlValue}?rental_id=${rentalId}&start_date=${startDate}&end_date=${endDate}`, {
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => response.json())
      .then(data => {
        this.hideLoadingIndicator()
        
        if (data.available) {
          this.totalPriceTarget.textContent = data.total_price
          this.enableSubmitButton()
        } else {
          this.showError("The selected dates are not available.")
          this.disableSubmitButton()
        }
      })
      .catch(error => {
        this.hideLoadingIndicator()
        this.showError("An error occurred while checking availability.")
        console.error("Error checking availability:", error)
        this.disableSubmitButton()
      })
  }

  showLoadingIndicator() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.remove("hidden")
    }
  }

  hideLoadingIndicator() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add("hidden")
    }
  }

  enableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
      this.submitButtonTarget.classList.add("hover:bg-indigo-700")
    }
  }

  disableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
      this.submitButtonTarget.classList.remove("hover:bg-indigo-700")
    }
  }

  showError(message) {
    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.textContent = message
      this.errorContainerTarget.classList.remove("hidden")
    }
  }

  clearErrors() {
    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.textContent = ""
      this.errorContainerTarget.classList.add("hidden")
    }
  }

  dateChanged() {
    this.updateTotalPrice()
  }

  submit(event) {
    if (this.hasSubmitButtonTarget && this.submitButtonTarget.disabled) {
      event.preventDefault()
    }
  }
}
